import { useEffect, useState } from "react";

export const ScrollProgress = () => {
  const [progress, setProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY;
      const height = document.body.scrollHeight - window.innerHeight;
      const percentage = height > 0 ? Math.round((scrolled / height) * 100) : 0;
      setProgress(percentage);
      setIsVisible(scrolled > 200);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 flex h-14 w-14 items-center justify-center rounded-full border border-red-200 bg-white text-sm font-semibold text-red-500 shadow-lg transition hover:scale-105 hover:text-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-offset-2"
      aria-label="Дээш буцах"
    >
      <span>{progress}%</span>
    </button>
  );
};
